import styled from 'styled-components';

interface IStatus {
  status: string;
}

export const Container = styled.div`
  h3 {
    color: #5d5d5d;
    font-size: 14px;
    font-weight: 400;
  }

  p {
    color: #000;
    font-size: 14px;
    font-weight: 400;
  }

  .default {
    max-width: 64px;
    max-height: 64px;
    border: solid 1px #002f6c;
    border-radius: 4px;
  }

  .bg-orange {
    background-color: #ff842f;
    padding: 4px 8px;
    height: 32px;
    width: 32px;
    display: inline-block;
  }

  .priority {
    line-height: 100%;
    span {
      font-size: 10px;
    }
  }

  button:disabled {
    opacity: 0.5;
  }
`;

export const Status = styled.p<IStatus>`
  color: ${(props) => {
    switch (props.status) {
      case 'Em Alteração':
      case 'Fim Inscrições':
      case 'Em Andamento':
      case 'Cadastrando':
        return '#000';
      default:
        return '#fff';
    }
  }}!important;
  background-color: ${(props) => {
    switch (props.status) {
      case 'Cadastrando':
        return '#bbb';
      case 'Rascunho':
        return '#4b4b4d';
      case 'Em Alteração':
        return '#dbb100';
      case 'A Publicar':
        return '#674ea7';
      case 'Aprovado':
        return '#dbb100';
      case 'Aberto':
        return '#427242';
      case 'Fim Inscrições':
        return '#ff9900';
      case 'Fechado':
        return '#20124d';
      case 'Em Andamento':
        return '#00ffff';
      case 'Encerrado':
        return '#002f6c';
      case 'Finalizado':
        return '#20124d';
      case 'Cancelado':
        return '#bf2216';
      case 'Esgotado':
        return '#f00';
      default:
        return '#000';
    }
  }};
  padding: 3px;
`;
